import { render, staticRenderFns } from "./BasePhone.vue?vue&type=template&id=f671f5c0&scoped=true&"
import script from "./BasePhone.vue?vue&type=script&lang=js&"
export * from "./BasePhone.vue?vue&type=script&lang=js&"
import style0 from "./BasePhone.vue?vue&type=style&index=0&id=f671f5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f671f5c0",
  null
  
)

export default component.exports